import { Maybe } from 'maybe-not';
import { Change, Verb } from 'q2-tecton-common/lib/types/config';
import { PartialRecord } from 'q2-tecton-common/lib/types/record';
import SDKMessageBus from '../utility/message-bus';

export default function manageChanges(
    messageBus: SDKMessageBus,
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('manageChanges')) {
        return;
    }
    function _manageChanges(changeData: PartialRecord<Verb, Change[]>): Promise<XMLHttpRequest> {
        if (arguments.length === 1) {
            const validDataCount = Object.values(changeData || {})
                .filter(Array.isArray)
                .reduce((acc, cur) => acc + cur.length, 0);
            if (validDataCount === 0) {
                throw new Error('No valid data found to be changed');
            }
            return messageBus
                .sendRequest('manageChanges', Maybe.just({ changeData }).map(JSON.stringify))
                .then((result: any) => {
                    return result;
                });
        } else {
            throw new Error('manageChanges takes 1 argument');
        }
    }
    return _manageChanges;
}
